export type GapHostItem = { host: string; i: number };
export type GapHostApiItem = { host: string; i?: number };

export const hostApiFormatter = (
  hosts: GapHostApiItem[] | null | undefined
): string[] =>
  hosts
    ?.map(({ host }) => host)
    ?.filter(host => host)
    ?.map(host => host.trim())
    ?.filter(host => host) ?? [];
